module.exports = __webpack_public_path__ + "img/security-2-supp.7905fb10.png";